<template>
    <teleport to="#app-sidebar">
        <AppCart v-if="proofcard != ''" />

        <div v-else class="uk-flex uk-flex-middle uk-width-1-1">
            <Form
                @submit="submit()"
                id="payment-form"
                :validation-schema="form_schema.validation"
                v-slot="{ errors }"
                class="uk-width-1-1"
            >
                <div class="uk-child-width-1-1" uk-grid>
                    <div>
                        <div class="uk-card uk-card-primary uk-card-body uk-rounded">
                            <div class="uk-grid-small" uk-grid>
                                <div
                                    v-for="field in form_schema.online_code" :key="field.key"
                                    class="uk-width-1-1" >
                                    <label class="uk-h3" for="form-stacked-text">{{ field.label }}</label>
                                    <div class="uk-text-small">{{ field.help }}</div>
                                    <Field
                                        class="uk-input uk-rounded"
                                        :placeholder="field.label"
                                        :name="field.name"
                                        as="input"
                                        :class="{ 'uk-form-danger': errors.[field.name] }"
                                        :value="customer.[field.name]"
                                        @input="updateCustomer"
                                    />
                                    <div class="invalid-feedback">{{ errors.[field.name] }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <button class="uk-button uk-button-large uk-width-small uk-button-primary uk-rounded">
                            <div v-if="loading" uk-spinner></div>
                            <span v-else>Start</span>
                        </button>
                    </div>

                    <div v-if="response.error">
                        <div class="uk-alert-danger" uk-alert>
                            <a class="uk-alert-close" uk-close></a>
                            <p>{{ response.error }}</p>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    </teleport>

    <div v-if="proofcard != ''" class="uk-text-center">
        <h1>Photocard Preview</h1>
        <img :src="proofcard" alt="">
        <p class="uk-text-large">View your images above and head to the products page when you are ready.</p>
        <div class="uk-margin" uk-grid>
            <div class="uk-width-1-2 uk-text-left" uk-margin>
                <router-link class="uk-margin-right uk-button uk-button-large uk-button-primary uk-rounded" :to="{ name: 'Products' }">Go to Products</router-link>
            </div>
            <div class="uk-width-1-2 uk-text-right">
                <button @click="startAgain()" class="uk-margin-right uk-button uk-button-large uk-button-secondary uk-input-rounded">
                    <span>Start Again</span>
                </button>
            </div>
        </div>
        <div id="help"><BlockHelp /></div>
    </div>

    <div v-else class="">
        <h1>School Photos</h1>
        <p class="uk-text-large">To get started, enter your details in the form <span class="uk-hidden@s">below</span> <span class="uk-visible@s">to the right</span> </p>
        <div id="help"><BlockHelp /></div>
    </div>
</template>

<script>
import AppCart from "@/components/app/Cart"
import BlockHelp from "@/components/blocks/Help"

import { mapState, mapActions, mapGetters } from 'vuex'

import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'

export default {
    components: {
        AppCart,
        BlockHelp,
        Form,
        Field,
    },

    data () {
        return {
            loading: false,
            response: [],
            form_schema: {
                online_code: [
                    { label: 'Email Address',       name: 'email',       as: 'input', help: '', },
                    { label: 'School Code / Name', name: 'school',      as: 'input', help: 'Please enter the school code or name as it appears on your proof card', },
                    { label: 'Online Code',         name: 'online_code', as: 'input', help: '', },
                ],

                validation: Yup.object().shape({
                    email:       Yup.string().email('Email format is invalid').required('Email is required'),
                    school:      Yup.string().required('School Name or code is required'),
                    online_code: Yup.string().required('Code is required'),
                }),
            },
        }
    },

    mounted() {
    },

    computed: {
        ...mapState({
            cartProducts: state => state.cart_products,
            payment: state => state.payment,
        }),
        ...mapGetters({
            customer: 'customer',
            responseData: 'responseData',
            school: 'school',
            proofcard: 'proofcard',
        }),
    },

    methods: {
        ...mapActions ({
            updateCustomer: 'updateCustomer',
            updateResponseData: 'updateResponseData',
            startAgain: 'startAgain',
        }),

        submit(event) {
            let _this = this

            // Are we already loading?
            if (this.loading == true) { return }

            // Clear the response, this clear any error messages so they don't trigger visual responses
            this.response = []

            this.loading = true

            this.axios.post('/api/v1/online-code', {
                email:       _this.customer.email,
                school:      _this.customer.school,
                online_code: _this.customer.online_code,
            })
            .then(function(response) {
                _this.loading = false
                _this.response = response.data

                if (_this.response.set_school) {
                    _this.updateResponseData(_this.response)
                }
            })
            .catch(function(error) {})
        },
    },

}
</script>
<style>
.uk-rounded {
    border-radius: 5px;
}

</style>
